export const CONSTANTS = {
  DEFAULT_TIME_FORMAT: "hh:mm a",
  DEFAULT_DATETIME_FORMAT: "YYYY-MM-DD HH:mm",
  DEFAULT_DATE_FORMAT: "YYYY-MM-DD",
  OLD_DATETIME_FORMAT: "DD/MM/YYYY HH:mm",
  OLD_DATE_FORMAT: "DD/MM/YYYY",
  DEFAULT_DATE_FORMAT2: "MMM D, YYYY",
  DEFAULT_PHONE_NUMBER_MASK: "____________________",

  COLOR_SEQUENCE: [
    "deep-orange",
    "purple",
    "pink",
    "light-green",
    "red",
    "pink",
    "indigo",
    "blue",
    "light-blue",
    "cyan",
    "deep-purple",
    "brown",
    "blue-gray",
    "amber",
    "teal"
  ]

};

export const MESSAGES = {
  MANUAL_REQUEST_CANCELLATION: "Manual request cancellation."
};

export const COMMON_VALUES = {
  SUPPORT_TICKET_STATUS_CLOSED: "closed"
}
